var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { boundMethod } from 'autobind-decorator';
import { PureComponent } from 'react';
import COUNTRIES from './countries.json';
export const withCountries = (Component) => {
    class WithCountries extends PureComponent {
        constructor(props) {
            super(props);
            this.state = {
                items: COUNTRIES,
                searchTerm: '',
            };
        }
        getItems() {
            this.setState({ items: COUNTRIES });
        }
        handleSearchTermChange(searchTerm = '') {
            this.setState({ searchTerm }, () => {
                const countriesFiltered = searchTerm.length
                    ? COUNTRIES.filter((country) => country.name
                        .toLowerCase()
                        .startsWith(this.state.searchTerm.toLowerCase()) ||
                        country.phone.startsWith(this.state.searchTerm))
                    : COUNTRIES;
                this.setState({ items: countriesFiltered });
            });
        }
        getInjectedProps(props, state) {
            const { items, searchTerm } = state;
            return this.memoizedGetInjectedProps(searchTerm, items);
        }
        memoizedGetInjectedProps(searchTerm, items) {
            return {
                searchTerm,
                items,
                getItems: this.getItems,
                searchTermChange: this.handleSearchTermChange,
            };
        }
        render() {
            return (_jsx(Component, Object.assign({}, this.props, { countries: this.getInjectedProps(this.props, this.state) })));
        }
    }
    __decorate([
        boundMethod
    ], WithCountries.prototype, "getItems", null);
    __decorate([
        boundMethod
    ], WithCountries.prototype, "handleSearchTermChange", null);
    __decorate([
        boundMethod
    ], WithCountries.prototype, "getInjectedProps", null);
    return WithCountries;
};
